export default class InvalidResetPasswordMethod extends Error {
  provider: string;

  constructor(provider: string) {
    super(`Invalid reset password method. Try signing in with ${provider}`);

    this.provider = provider;
  }
}
